<template>
  <div class="zigzag-service-layout">
    <!-- Intro section -->
    <section v-if="mainTitle || mainDescription" class="wl-section bg-white text-center pb-0" style="padding-top: 4rem;">
        <div class="container">
            <h2 class="wl-section-title mb-4">{{ mainTitle }}</h2>
            <p v-if="mainDescription" class="lead text-muted mx-auto" style="max-width: 800px;">{{ mainDescription }}</p>
        </div>
    </section>

    <!-- Zigzag Sections -->
    <section 
      v-for="(section, index) in sections" 
      :key="index"
      class="wl-section py-5"
      :class="{ 'bg-light': index % 2 !== 0, 'bg-white': index % 2 === 0 }"
    >
      <div class="container py-4">
        <div class="row align-items-center" :class="{ 'flex-row-reverse': index % 2 !== 0 }">
          <div class="col-md-7 mb-4 mb-md-0" :class="{ 'ps-md-5': index % 2 === 0, 'pe-md-5': index % 2 !== 0 }">
            <p v-if="section.label" class="wl-nutrition__label">{{ section.label }}</p>
            <h2 v-if="section.title" class="wl-nutrition__title">{{ section.title }}</h2>
            <p v-if="section.subtitle" class="wl-nutrition__subtitle">{{ section.subtitle }}</p>
            
            <template v-if="section.paragraphs">
                <p v-for="(p, pIndex) in section.paragraphs" :key="pIndex" class="wl-nutrition__body" v-html="p"></p>
            </template>
            <p v-else-if="section.description" class="wl-nutrition__body" v-html="section.description"></p>

            <ul v-if="section.list && section.list.length > 0" class="wl-nutrition__list">
              <li v-for="(item, iIndex) in section.list" :key="iIndex" v-html="item"></li>
            </ul>
            
            <p v-if="section.closing" class="wl-nutrition__closing mt-4">{{ section.closing }}</p>
          </div>
          <div class="col-md-5">
            <template v-if="section.videoEmbeds && section.videoEmbeds.length > 0">
              <div class="d-flex flex-column gap-3 align-items-center">
                <iframe
                  v-for="(videoUrl, vIndex) in section.videoEmbeds"
                  :key="'video-' + vIndex"
                  width="320"
                  height="568"
                  style="max-width: 100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);"
                  :src="videoUrl"
                  title="YouTube Shorts"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </template>
            <template v-else-if="section.image">
              <img
                :src="section.image"
                :alt="section.title"
                class="wl-nutrition__image shadow-lg"
                style="width: 100%; border-radius: 16px; object-fit: cover;"
              />
            </template>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to action -->
    <section v-if="!hideBookButton" class="wl-section text-center py-5 bg-white">
      <div class="container">
        <a
          href="https://diversecarenow.as.me/schedule/6a240cde/?utm_source=WEBSITE"
          target="_blank"
          rel="noopener noreferrer"
          class="wl-btn wl-btn--dark"
          style="background-color: var(--pool-600); border-color: var(--pool-600); color: white;"
        >
          <i class="bi bi-calendar2-check"></i> {{ $i18n.locale === 'pt_BR' ? 'Marcar Consulta' : ($i18n.locale === 'es' ? 'Agendar Cita' : 'Book Appointment') }}
        </a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ZigzagServiceLayout',
  props: {
    mainTitle: {
      type: String,
      default: ''
    },
    mainDescription: {
      type: String,
      default: ''
    },
    sections: {
      type: Array,
      required: true,
      default: () => []
    },
    hideBookButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.zigzag-service-layout {
  overflow-x: hidden;
}

.bg-light {
    background-color: var(--pool-50) !important;
}

.wl-nutrition__label {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--pool-700);
  margin-bottom: 8px;
}

.wl-nutrition__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 12px;
  color: var(--wl-text);
}

.wl-nutrition__subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--pool-600);
  margin-bottom: 20px;
}

.wl-nutrition__body {
  font-family: 'Manrope', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: var(--wl-text);
  margin-bottom: 16px;
  line-height: 1.7;
}

.wl-nutrition__list {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  padding-left: 20px;
  margin-bottom: 20px;
  color: var(--wl-text);
  line-height: 1.8;
}

.wl-nutrition__list li {
  margin-bottom: 8px;
}

.wl-nutrition__closing {
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  color: var(--wl-text);
  margin-bottom: 24px;
}

.wl-section-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: var(--pool-700);
}
</style>
